import React from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'

const LegalNav: React.FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <Divider />
      <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.legal')}</p>
      <SideNavItem
        href="/legal/terms"
        external
        label={t('siteSidebar.termsOfUse')}
        iconName="nf-legal"
      />
      <SideNavItem
        href="/legal/privacy"
        external
        label={t('siteSidebar.privacyPolicy')}
        iconName="nf-legal"
      />
      <SideNavItem
        href="/legal/copyright"
        external
        label={t('siteSidebar.copyrightInfringement')}
        iconName="nf-legal"
      />
    </>
  )
}

export default LegalNav
